/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/OSL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to https://devdocs.prestashop.com/ for more information.
 *
 * @author    PrestaShop SA and Contributors <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/OSL-3.0 Open Software License (OSL 3.0)
 */

import prestashop from 'prestashop'

export class SubmitForm
{
    init(){
        const _this = this

        $(document.body).on('submit', '.js-velcome-form-quote', (e) => {
            e.preventDefault()

            const publicKey = prestashop.modules.vequote.recaptchaPublicKey
            const version = parseInt(prestashop.modules.vequote.recaptchaVersion, 10)
            const $tokenInput = $('.js-velcome-form-quote #captcha-box-custom')

            if (version === 3 && publicKey && $tokenInput.length && typeof grecaptcha !== 'undefined') {
                grecaptcha.ready(() => {
                    grecaptcha.execute(publicKey, { action: 'quote' }).then((token) => {
                        $tokenInput.val(token)
                        _this.send()
                    })
                })
            } else {
                _this.send()
            }
        })
    }

    send() {
        const data = new FormData()

        data.append('ajax', 1)

        $('.js-velcome-form-quote').find('input, select, textarea').each(function () {
            switch ($(this).attr('type')) {
                case 'file':
                    data.append($(this).attr('name'), $(this)[0].files[0])
                    break
                case 'checkbox':
                case 'radio':
                    if ($(this).is(':checked') && $(this).val() !== 'on' && $(this).val() !== 'off') {
                        data.append($(this).attr('name'), $(this).val())
                    }
                    break
                default:
                    data.append($(this).attr('name'), $(this).val())
                    break
            }
        })

        $.post({
            url: prestashop.modules.vequote.ajaxVelcomeQuoteLink,
            dataType: 'json',
            data: data,
            processData: false,
            contentType: false,
            success: response => {
                if(response.success) {
                    $('.js-velcome-form-message').html(
                        `<div class="alert alert-success">${response.message}</div>`
                    )
                } else {
                    $('.js-velcome-form-message').html(
                        `<div class="alert alert-danger">${response.message}</div>`
                    )
                }
            },
            error: message => {
                console.error(message)
            }
        })
    }
}